<template>
  <tr
    v-for="(row, index) in rows"
    :key="index"
    class="tw-h-9 tw-border-b tw-border-primary-grey-100/80 hover:tw-bg-primary-grey-50"
    :class="'tw-bg-white'"
  >
    <td
      v-for="cell in row"
      :key="row[cell]"
      class="h-2 bg-slate-200 rounded tw-animate-pulse tw-whitespace-nowrap tw-px-2"
    >
      <div class="tw-w-30 tw-h-5 tw-animate-pulse tw-bg-primary-grey-25"></div>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps<{
  rows: Record<string, string>[];
  className?: Record<string, boolean> | string[] | string;
}>();

const { rows } = toRefs(props);
</script>
